module.exports = __webpack_public_path__ + "static/img/record-peixun.fbcfe0a8.jpg";